/* global window */

export default function supportsLocalStorage() {
  try {
    return 'localStorage' in globalThis && globalThis.localStorage !== null;
  } catch {
    return false;
  }
}
